import { render, staticRenderFns } from "./CalendarAccount.vue?vue&type=template&id=635b4be5"
import script from "./CalendarAccount.vue?vue&type=script&lang=js"
export * from "./CalendarAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports